import React from 'react';
import {FcGoogle} from "react-icons/fc"
import { service } from '../services/firebase';
import { useDispatch, useSelector } from'react-redux';
import { userRegister } from '../slices/slices';
import { redirect, Navigate } from "react-router-dom";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
const Login = () => {
  const dispatch = useDispatch()
  const state = useSelector(state => state)
  const auth = async() =>{
    const usuario = getAuth();
    const provider = new GoogleAuthProvider();
signInWithPopup(usuario, provider)
  .then((result) => {
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    const user = result.user
    const data = {
      email: user.email,
      name: user.displayName,
      uid: user.uid,
      photo: user.photoURL
    }
    if(user){
      dispatch(userRegister(data))
    }
    
  }).catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    const email = error.customData.email;
    const credential = GoogleAuthProvider.credentialFromError(error);
  });  
  } 
    


 
  return (
    <div className='login'>
      <img src="./img/login-img.png" alt="" />
      <p className='title'>Cada dia mejor y mejor</p>
      <div className="btn primary" onClick={auth}>
      <FcGoogle /> Iniciar sesion con Google
      </div>
      {
        state.user.userData && <Navigate to="/app"></Navigate>
      }
      
    </div>
  );
};

export default Login;